import { Component, OnInit, OnChanges, Input, Output, EventEmitter, forwardRef, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl, AbstractControl, Validator, Validators } from '@angular/forms';

import { PageContentService, SessionStorageService } from '../../core/index.service';
import { PageContent } from '../../core/index.model';

declare var $: any;

@Component({
    selector: 'pnx-igtxteditor',
    templateUrl: './infgtexteditor.control.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InfgTextEditorControl), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => InfgTextEditorControl), multi: true }
    ]
})
export class InfgTextEditorControl implements OnChanges, ControlValueAccessor, Validator {

    @Input('value') _value;
    @Input() txtId;
    @Input() labelId: string = '';
    @Input() label: string = '';
    @Input() labelstyle: string = 'control-label';
    @Input() defaultLabel: string = '';
    @Input() placeholderId: string = '';
    @Input() defaultPlaceholder: string = '';
    @Input() placeholder: string = '';
    @Input() pagecontent: PageContent;
    @Input() texteditorcontainerstyle: string = 'col-md-9';
    @Input() control: FormControl;
    @Input() mandatory: boolean = false;
    @Input() cleartextondisable: boolean = false;
    @Input() disable: boolean = false;
    //@Output() onChange: EventEmitter<string> = new EventEmitter<string>();

    disabled: boolean = false;

    constructor(private pageContentService: PageContentService,
        private storageService: SessionStorageService) { }

    ngOnInit() {
        if (this.pagecontent) {
            if (!this.pageContentService.pageContent) {
                this.pageContentService.pageContent = this.pagecontent;
            }
        }

        this.initializeTxtEditor(this.txtId);
    }

    ngOnChanges(Changes: SimpleChanges) {
        if (Changes['disable']) {
            this.setDisabledState(Changes['disable'].currentValue);
        }

        this.onChangeCb(this.value);

        if (this.control) {
            this.validate(this.control);
        }

        let labelValue = (this.labelId) ? this.pageContentService.getKeyTxt(this.labelId, this.storageService.getLang()) : this.label;
        let placeHolderValue = (this.placeholderId) ? this.pageContentService.getKeyTxt(this.placeholderId, this.storageService.getLang()) : this.placeholder;

        this.label = (labelValue) ? labelValue : this.defaultLabel;
        this.placeholder = (placeHolderValue) ? placeHolderValue : this.defaultPlaceholder;
    }

    ngAfterViewInit() { }

    initializeTxtEditor(itxt) {
        var self = this;
        $(function () {
            var height = $('html').hasClass('touch') ? 500 : 430;
            $("#htmlEditor" + itxt).igHtmlEditor({
                height: height,
                width: "100% !important"
            });

            var contentEditor = $("#htmlEditor" + itxt + "_editor");

            if (contentEditor.length > 0) {
                $(contentEditor[0].contentWindow.document).bind("keyup", function (e) {
                    self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
                });
            }

            $("#htmlEditor" + itxt).on("ightmleditoractionexecuted", function (evt, ui) {
                self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
            });

            $("#htmlEditor" + itxt).on("ightmleditorcut", function (evt, ui) {
                self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
            });

            $("#htmlEditor" + itxt).on("ightmleditorcopy", function (evt, ui) {
                self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
            });

            $("#htmlEditor" + itxt).on("ightmleditorpaste", function (evt, ui) {
                self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
            });

            $("#htmlEditor" + itxt).on("ightmleditorundo", function (evt, ui) {
                self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
            });

            $("#htmlEditor" + itxt).on("ightmleditorredo", function (evt, ui) {
                self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
            });
        });

    }

    setHtmlContent(html: string) {
        if (!$("#htmlEditor" + this.txtId).igHtmlEditor("getContent", "text"))
            html = "";
        
        this._value = html;
        this.onChangeCb(html);
        //this.onChange.emit(html);
    }

    texteditor = new FormControl();

    onChangeCb: (_: any) => void = () => { };

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        var htmlEditor = $("#htmlEditor" + this.txtId);
        
        if (htmlEditor && htmlEditor.igHtmlEditor()) {
            htmlEditor.igHtmlEditor("setContent", val, "html");
        }
            
        this.onChangeCb(val);
    }

    writeValue(value): void {
        this.value = value;
        this.texteditor.setValue(this.value);
    }

    registerOnChange(fn: any): void {
        this.onChangeCb = fn;
    }

    registerOnTouched(fn: any): void { }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;

        if (!this.texteditor.disabled && this.disabled && this.cleartextondisable) {
            this.value = '';
            this.texteditor.setValue(this.value);
            this.texteditor.disable();
        }
        else if (!this.texteditor.disabled && this.disabled) {
            this.texteditor.disable();
        }
        else if (this.texteditor.disabled) {
            this.texteditor.enable();
        }
    }


    public validate(parentControl: AbstractControl): { [key: string]: any } {
        const val = parentControl.value;
        if (this.mandatory) {
            this.texteditor.setValidators(Validators.required);
            parentControl.setValidators(Validators.required);

            if (!parentControl.value) {
                parentControl.setValue(null);
            }

            if (!val) {
                return { valid: false };
            }
        }
        else {

            this.texteditor.clearValidators();
            parentControl.clearValidators();

            if (!parentControl.value) {
                parentControl.setValue(null);
            }
        }

        if (!parentControl.disabled) {
            parentControl.disable();
        }

        return null;
    }

}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/infgtexteditor.control.ts